import * as THREE from "three";

const scene = new THREE.Scene();
console.log(scene);
export default scene;